module.exports = __webpack_public_path__ + "static/media/stripe_logo.29b3c783.jpg";